import React from "react";
import PropTypes from "prop-types";

const Row2ColumnsSeparator = (props) => {
  return (
    <div className="form__group form__group--has-columns">
      <div className="form__column">{props.children[0]}</div>
      <div className="line-vertical">{props.children[1]}</div>
      <div className="form__column">{props.children[2]}</div>
    </div>
  );
};

Row2ColumnsSeparator.propTypes = {
  config: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
};

export default Row2ColumnsSeparator;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Group/Row2ColumnsSeparator.js